import { EXPENSE_NAMES_BY_TYPE } from "web_myplann/Finances/constants";
import type { ExpenseEntry } from "web_myplann/Finances/Types/ExpenseEntry";
import {
	ClientFinancialPlanExpenseNameEnum,
	type ClientFinancialPlanExpenseTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const getAvailableExpenseNames = (
	expenses: ExpenseEntry[],
	type: ClientFinancialPlanExpenseTypeEnum,
) => {
	const usedNames = expenses
		.filter((expense) => expense.type === type)
		.map((expense) => expense.name);
	const hasSubcategory = usedNames.some(
		(name) => name !== ClientFinancialPlanExpenseNameEnum.Total,
	);

	return EXPENSE_NAMES_BY_TYPE[type].filter(
		(name) =>
			!usedNames.includes(name) &&
			!(name === ClientFinancialPlanExpenseNameEnum.Total && hasSubcategory),
	);
};
